import React, { useState } from 'react';
import './ReasoningChain.css';

const ReasoningChain = ({ explanation, dimension }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    if (!explanation || !explanation.reasoning_chain) {
        return (
            <div className="reasoning-chain no-data">
                <p>No reasoning chain available for this dimension</p>
            </div>
        );
    }

    const { reasoning_chain } = explanation;
    const {
        category,
        decision,
        reasoning_steps = [],
        conclusion,
        job_requirements_influencing = [],
        resume_sections_referenced = []
    } = reasoning_chain;

    return (
        <div className="reasoning-chain">
            <div className="reasoning-chain-header" onClick={() => setIsExpanded(!isExpanded)}>
                <div className="header-left">
                    <h4 className="dimension-name">{dimension || category}</h4>
                    <span className="decision-text">{decision}</span>
                </div>
                <div className="header-right">
                    <span className="steps-count">{reasoning_steps.length} steps</span>
                    <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
                </div>
            </div>

            {isExpanded && (
                <div className="reasoning-chain-content">
                    <div className="reasoning-steps">
                        <h5>Reasoning Steps</h5>
                        {reasoning_steps.length === 0 ? (
                            <p className="no-steps">No reasoning steps available</p>
                        ) : (
                            <div className="steps-list">
                                {reasoning_steps.map((step, idx) => (
                                    <div key={idx} className="reasoning-step">
                                        <div className="step-header">
                                            <span className="step-number">Step {step.step_number || idx + 1}</span>
                                            {step.confidence !== null && step.confidence !== undefined && (
                                                <span className="step-confidence">
                                                    Confidence: {(step.confidence * 100).toFixed(1)}%
                                                </span>
                                            )}
                                        </div>
                                        <p className="step-reasoning">{step.reasoning}</p>
                                        {step.evidence && step.evidence.length > 0 && (
                                            <div className="step-evidence">
                                                <strong>Evidence:</strong>
                                                <ul>
                                                    {step.evidence.map((ev, evIdx) => (
                                                        <li key={evIdx}>{ev}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {conclusion && (
                        <div className="reasoning-conclusion">
                            <h5>Conclusion</h5>
                            <p>{conclusion}</p>
                        </div>
                    )}

                    {job_requirements_influencing.length > 0 && (
                        <div className="job-requirements">
                            <h5>Job Requirements Influencing Decision</h5>
                            <ul>
                                {job_requirements_influencing.map((req, idx) => (
                                    <li key={idx}>{req}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {resume_sections_referenced.length > 0 && (
                        <div className="resume-sections">
                            <h5>Resume Sections Referenced</h5>
                            <div className="sections-tags">
                                {resume_sections_referenced.map((section, idx) => (
                                    <span key={idx} className="section-tag">{section}</span>
                                ))}
                            </div>
                        </div>
                    )}

                    {explanation.matched_requirements && explanation.matched_requirements.length > 0 && (
                        <div className="matched-requirements">
                            <h5>✅ Matched Requirements</h5>
                            <ul>
                                {explanation.matched_requirements.map((req, idx) => (
                                    <li key={idx}>{req}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {explanation.missing_requirements && explanation.missing_requirements.length > 0 && (
                        <div className="missing-requirements">
                            <h5>❌ Missing Requirements</h5>
                            <ul>
                                {explanation.missing_requirements.map((req, idx) => (
                                    <li key={idx}>{req}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {explanation.key_factors && explanation.key_factors.length > 0 && (
                        <div className="key-factors">
                            <h5>🔑 Key Factors</h5>
                            <ul>
                                {explanation.key_factors.map((factor, idx) => (
                                    <li key={idx}>{factor}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default ReasoningChain;

